import React from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import rocket from "../../assets/images/aboutUs/rocket";
import cloud1 from "../../assets/images/aboutUs/cloud1";
import cloud2 from "../../assets/images/aboutUs/cloud2";

function App() {
  return (
    <Grid
      container
      style={{
        background: " linear-gradient(#83b8fe, #ced9f2)",
        padding: "130px 10px",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        sx={{ margin: "0 30px" }}
      >
        <h1>About Us</h1>
      </Grid>
      <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
        <Grid container style={{ margin: "0px 30px" }}>
          <Typography
            sx={{
              fontSize: "1.5rem",
              fontFamily: "'Open Sans', sans-serif",
              margin: "30px 0",
            }}
          >
            Google Developer Student Club (GDSC) is a Google Developers program
            for university students to enhance their technical skills. The club
            will be open to any student, ranging from beginner developers to
            advanced developers who want to further their skills. The club is
            intended as a space for students to try out new ideas and
            collaborate to help each other out.
          </Typography>
          <Button
            endIcon={<SendIcon />}
            href="https://gdsc.community.dev/accounts/login/?next=/srm-institute-of-science-and-technology-ramapuram-chennai/"
          >
            Learn more
          </Button>
        </Grid>
      </Grid>
      <Grid
        item
        // xs={{ display: "none"}}
        // sm={{ display: "none" }}
        md={4}
        lg={4}
        xl={4}
        sx={{ width: "50%", height: "100%", margin: "50px 0 0 0" }}
      >
        <Box
          component="img"
          src={rocket}
          style={{ width: "50%", height: "50%" }}
        ></Box>
        <Box
          component="img"
          src={cloud1}
          style={{ width: "50%", height: "50%" }}
        ></Box>
        <Box
          component="img"
          src={cloud2}
          style={{ width: "50%", height: "50%" }}
        ></Box>
      </Grid>
    </Grid>
  );
}

export default App;
